import type { DocumentData, DocumentTemplate } from "./api";

const configuredDesignerUrl = import.meta.env.VITE_PDFME_DESIGNER_URL?.trim();

export function localDesignerUrl(): string {
  const url = configuredDesignerUrl
    ? new URL(configuredDesignerUrl, window.location.origin)
    : new URL(`${window.location.protocol}//${window.location.hostname}:8091`);
  // The Designer is a separately deployed application. Version its entry URL so
  // an already open ObvioWMS tab cannot retain an older iframe after deployment.
  url.searchParams.set("obviowmsDesignerVersion", "zpl-label-layout-v2");
  return url.toString();
}

export function generateDocumentPdf(
  template: DocumentTemplate, data: DocumentData
): Promise<{ blob: Blob; filename: string }> {
  return new Promise((resolve, reject) => {
    const url = localDesignerUrl();
    const origin = new URL(url).origin;
    const requestId = crypto.randomUUID();
    const iframe = document.createElement("iframe");
    iframe.src = url;
    iframe.hidden = true;
    iframe.setAttribute("aria-hidden", "true");
    document.body.appendChild(iframe);

    const cleanup = () => {
      window.clearTimeout(timeout);
      window.removeEventListener("message", receive);
      iframe.remove();
    };
    const fail = (message: string) => {
      cleanup();
      reject(new Error(message));
    };
    const receive = (event: MessageEvent) => {
      if (event.source !== iframe.contentWindow || event.origin !== origin
          || event.data?.source !== "obviowms-pdfme") return;
      if (event.data.type === "designer-ready") {
        iframe.contentWindow?.postMessage({
          source: "obviowms", type: "generate-document", requestId,
          template: template.template, values: data.values
        }, origin);
      }
      if (event.data.requestId === requestId
          && event.data.type === "document-generation-error") {
        fail(event.data.message ?? "Génération impossible.");
      }
      if (event.data.requestId === requestId
          && event.data.type === "document-generated") {
        const blob = new Blob([event.data.buffer], { type: "application/pdf" });
        cleanup();
        resolve({ blob, filename: data.filename });
      }
    };
    window.addEventListener("message", receive);
    const timeout = window.setTimeout(
      () => fail("L’éditeur documentaire ne répond pas."), 20_000
    );
  });
}
